import React from 'react';
import Header from '../components/Header';
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";

function Privacy() {
  const [user] = useAuthState(auth);

  return (
    <div id="general_screen" className="d-flex align-items-center flex-column mb-0 px-3 main_screen dashboard_screen">
      <Header user={user} />
      <style>{`#general_screen h2 { font-size: 1.4rem; } #general_screen a { color: #fff; }`}</style>
      <div className="container mt-5">
        <h1>Privacy &amp; Cookie Policy</h1>
        <p><strong>Effective Date:</strong> May 29th, 2025</p>

        <h2>1. Information We Collect</h2>
        <h3>Personal Information</h3>
        <ul>
          <li><strong>Name and Email:</strong> We collect your name and email address when you create an account</li>
          <li><strong>Movie Ratings:</strong> We store the movies you add and your ratings (1-5 stars) in our database</li>
        </ul>
        <h3>Technical Information</h3>
        <ul>
          <li><strong>Basic Usage Data:</strong> We may collect basic technical information about how you use our service for functionality purposes</li>
          <li><strong>No Analytics:</strong> We do not use Google Analytics or similar tracking services</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Provide and maintain your movie rating service</li>
          <li>Store your personal movie collection and ratings</li>
          <li>Communicate with you about service updates or issues</li>
          <li>Improve our service functionality</li>
        </ul>
        <p>We do not:</p>
        <ul>
          <li>Sell your personal information to third parties</li>
          <li>Use your data for advertising purposes</li>
          <li>Share your movie preferences with others without your consent</li>
        </ul>

        <h2>3. Data Storage and Security</h2>
        <ul>
          <li><strong>Database:</strong> Your data is securely stored using Google Firestore</li>
          <li><strong>Security:</strong> We implement appropriate security measures to protect your information</li>
          <li><strong>Data Retention:</strong> We keep your data as long as your account is active, or as needed to provide our service</li>
        </ul>

        <h2>4. Third-Party Services</h2>
        <p>We use the following external services that may collect or process data:</p>
        <h3>Google Firestore</h3>
        <ul>
          <li><strong>Purpose:</strong> Database for storing your account information and movie ratings</li>
          <li><strong>Data Shared:</strong> Your name, email, and movie ratings</li>
          <li><strong>Privacy Policy:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a></li>
        </ul>
        <h3>Google Fonts</h3>
        <ul>
          <li><strong>Purpose:</strong> Web fonts for better typography</li>
          <li><strong>Data:</strong> May collect basic technical information (IP address, browser type)</li>
          <li><strong>Privacy Policy:</strong> <a href="https://developers.google.com/fonts/faq/privacy" target="_blank" rel="noopener noreferrer">Google Fonts Privacy Policy</a></li>
        </ul>
        <h3>Bootstrap CDN</h3>
        <ul>
          <li><strong>Purpose:</strong> Styling framework for our user interface</li>
          <li><strong>Data:</strong> May collect basic technical information when loading resources</li>
          <li><strong>Note:</strong> This is a content delivery network service</li>
        </ul>
        <h3>The Movie Database (TMDb) API</h3>
        <ul>
          <li><strong>Purpose:</strong> Retrieving movie information and metadata</li>
          <li><strong>Data:</strong> No personal information is shared; we only request general movie data</li>
          <li><strong>Privacy Policy:</strong> <a href="https://www.themoviedb.org/privacy-policy" target="_blank" rel="noopener noreferrer">TMDb Privacy Policy</a></li>
        </ul>

        <h2>5. Cookies and Similar Technologies</h2>
        <h3>Essential Cookies</h3>
        <p>We use essential cookies that are necessary for the service to function, including:</p>
        <ul>
          <li>Authentication cookies to keep you logged in</li>
          <li>Session cookies for basic functionality</li>
        </ul>
        <h3>No Tracking Cookies</h3>
        <p>We do not use:</p>
        <ul>
          <li>Advertising cookies</li>
          <li>Analytics cookies</li>
          <li>Social media tracking cookies</li>
          <li>Third-party marketing cookies</li>
        </ul>

        <h2>6. Your Rights and Choices</h2>
        <ul>
          <li><strong>Access</strong> your personal data</li>
          <li><strong>Update</strong> your account information</li>
          <li><strong>Delete</strong> your account and all associated data</li>
          <li><strong>Export</strong> your movie ratings data</li>
          <li><strong>Contact us</strong> with privacy concerns</li>
        </ul>

        <h2>7. Data Transfers</h2>
        <p>Your data may be processed and stored on servers located outside your country, including in the United States through Google's infrastructure. We ensure appropriate safeguards are in place.</p>

        <h2>8. Children's Privacy</h2>
        <p>Our service is not intended for children under 13. We do not knowingly collect personal information from children under 13.</p>

        <h2>9. Changes to This Policy</h2>
        <p>We may update this Privacy and Cookie Policy from time to time. We will notify you of any material changes by email or through our service.</p>

        <h2>10. Contact Us</h2>
        <p>If you have questions about this Privacy and Cookie Policy or want to exercise your rights, please contact us at <a href="mailto:simone@lamorbidamacchina.com">simone@lamorbidamacchina.com</a>.</p>

        <hr />
        <p><em>Last updated: May 29th, 2025</em></p>
      </div>
    </div>
  );
}

export default Privacy; 